const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { Button } = require('commonsComponents/button');
require('./brokerETFsProductFileViewDocumentation.scss');

const BrokerETFsProductFileViewDocumentation = ({ product }) => (
    <div className="footer__documentation">
        <div className="row">
            <div className="col-md-12 col-xs-12">
                <p className="documentation__title">{formatText('broker-etfsProductFileViewDocumentationTitle')}</p>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 col-xs-12">
                <ul className="list-inline documentation__files">
                    {
                        product.map((doc, i) => (
                            doc.link ? (
                                <li key={i}>
                                    <Button
                                        iconClass="icon icon-descargar"
                                        onClick={() => {
                                            doc.fireTagging();
                                            window.open(doc.link, '_blank');
                                        }}
                                        key={i.toString()}
                                    >
                                        <FormattedText value={doc.titlePDF} />
                                    </Button>
                                </li>
                            ) : (
                                <li key={i}>
                                    <Button
                                    onClick={() => doc.fireTagging()}
                                        iconClass="icon icon-descargar"
                                        disabled={true}
                                        key={i.toString()}
                                        extraClass="documentation__files-button-disabled"
                                    >
                                        <FormattedText value={doc.titlePDF} />
                                    </Button>
                                </li>
                            )
                        ))
                    }
                </ul>
            </div>
        </div>
    </div>
);


BrokerETFsProductFileViewDocumentation.propTypes = {
    product: PropTypes.object.isRequired,
};


module.exports = BrokerETFsProductFileViewDocumentation;
